import { useEffect } from "react";
import PropTypes from "prop-types";
import SmartDPHotelDescription from "app/pages/SmartDP/Quote/HotelDescription/SmartDPHotelDescription";
import { bindActionCreators } from "redux";
import { fetchSDPAccommodationDescription } from "app/pages/SmartDP/smartDPActionCreators";
import { connect } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { closeSlideshow, openSlideshow } from "app/pages/.shared/Slideshow/SlideShowActionCreators";
import { parseQueries } from "app/utils/routerUtils";
import { checkForSpecialOffer } from "app/pages/Booking/Payment/paymentSelector";
import get from "lodash/get";
import usePrintMode from "app/reducers/usePrintMode";
import { startPrint } from "app/reducers/printActionCreators";
import { fetchStopoverAccommodationDescription } from "app/pages/Stopover/stopoverActionCreators";

const SmartDPHotelDescriptionContainer = props => {
	const {
		quotationCode,
		closeSlideshow,
		isStopover,
		isHotelOnly,
		fetchSDPAccommodationDescription,
		fetchStopoverAccommodationDescription,
		startPrint,
	} = props;
	const params = useParams();
	const location = useLocation();

	const isPrintMode = usePrintMode();

	useEffect(() => {
		if (isPrintMode) {
			startPrint();
		}
	}, [isPrintMode]);

	useEffect(() => {
		if (!isHotelOnly) {
			const query = parseQueries(location.search);
			const { accommodationId, code } = params;
			const { accommodationId: accommodationIdFromQuery, stopoverDuration } = query;

			const codeForPayload = code || quotationCode;
			const accommodationIdForPayload = accommodationId || accommodationIdFromQuery;

			if (codeForPayload && accommodationIdForPayload) {
				if (isStopover) {
					fetchStopoverAccommodationDescription({
						bookingFlowId: get(location, "state.code") || codeForPayload,
						accommodationId: accommodationIdForPayload,
						stopoverDuration,
					});
				} else {
					fetchSDPAccommodationDescription({
						code: get(location, "state.code") || codeForPayload,
						accommodationId: accommodationIdForPayload,
					});
				}
			}
		}
		return () => {
			closeSlideshow();
		};
	}, [
		location.search,
		location.state,
		params.accommodationId,
		params.code,
		quotationCode,
		isStopover,
		isHotelOnly,
	]);

	return <SmartDPHotelDescription {...props} />;
};

SmartDPHotelDescriptionContainer.propTypes = {
	quotationCode: PropTypes.string,
	fetchSDPAccommodationDescription: PropTypes.func,
	fetchStopoverAccommodationDescription: PropTypes.func,
	isStopover: PropTypes.bool,
	isHotelOnly: PropTypes.bool,
	closeSlideshow: PropTypes.func,
	startPrint: PropTypes.func,
};

const mapStateToProps = state => {
	return {
		hotel: state.ficheProduit,
		quotationCode: state.smartDP.code,
		slideshow: state.slideshow,
		hasSdpSpecialOffer: checkForSpecialOffer(state), // true si le back renvoi au moins un vol remboursable
		specialOfferInfos: state.ficheProduit.specialOffer,
		googleAPIKey: state.envVars.GOOGLE_API_KEY,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			fetchSDPAccommodationDescription,
			fetchStopoverAccommodationDescription,
			closeSlideshow,
			openSlideshow,
			startPrint,
		},
		dispatch
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SmartDPHotelDescriptionContainer);
